import { render, staticRenderFns } from "./SectionTitleCollapse.vue?vue&type=template&id=3191bf86&scoped=true"
import script from "./SectionTitleCollapse.vue?vue&type=script&lang=js"
export * from "./SectionTitleCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191bf86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3191bf86')) {
      api.createRecord('3191bf86', component.options)
    } else {
      api.reload('3191bf86', component.options)
    }
    module.hot.accept("./SectionTitleCollapse.vue?vue&type=template&id=3191bf86&scoped=true", function () {
      api.rerender('3191bf86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/ProposalDetails/SectionTitleCollapse.vue"
export default component.exports